import * as React from "react";

import { InitialProps, createStore } from "../../store";
import { App } from "../../components/App";

export function BigqueryTableViewerApp(props: InitialProps) {
  createStore(props);

  return <App />;
}
